((app, ng) => {

    app.component("quickLinks",
        {
            templateUrl: "/App/Dashboard/Tiles/QuickLinks/quick-links.template.html",
            controller: quickLinksController,
            bindings: {
                currentUser: "<"
            }
        });

    function quickLinksController(externalMarketingDollarApi, icomplyApi, iComplySettings, marketplaceSettings, portalApi, portalSettings, $q, userApi) {
        const $ctrl = this;

        ng.extend($ctrl,
            {
                ui: {
                    loading: false
                }
            });

        const getSsoUrl = (baseUrl, token) => {
            return `${baseUrl}/Sso?accesstoken=${token.Token}&expiration=${token.removeTokenExpiration}`;
        };

        //$ctrl.goToIcomply = () => {
        //    const win = window.open();

        //    win.document.write("Loading...");

        //    icomplyApi.getToken().then(response => {
        //        win.location.href = getSsoUrl(iComplySettings.baseUrl, response);
        //    },
        //        () => {
        //            win.document.write(" Failed. There was an error accessing this resource.");
        //        });
        //};

        $ctrl.goToPortal = (marketplaceEnvironment) => {
            const win = window.open();

            win.document.write("Loading...");

            portalApi.getToken()
                .then(response => {
                    let url = getSsoUrl(portalSettings.baseUrl, response);
                    if (!!marketplaceEnvironment) {
                        url = `${url}&marketplaceenvironment=${marketplaceEnvironment}`;
                    }

                    win.location.href = url;
                },
                    (error) => {
                        console.log("Error: " + error.status + " - " + error.data);

                        if (!!marketplaceEnvironment) {
                            win.location.href = marketplaceSettings.baseUrl;
                        } else {
                            win.location.href = portalSettings.baseUrl;
                        }
                    });
        };

        $ctrl.$onInit = () => {
            //$ctrl.marketingDollars = 0;
            //$ctrl.totalAum = 0;
            //$ctrl.totalIssuedPremium = 0;
            //$ctrl.ui.loading = true;
            //const promises = [
            //    userApi.getTotalIssuedPremium($ctrl.currentUser.Id),
            //    userApi.getTotalAum($ctrl.currentUser.Id),
            //    externalMarketingDollarApi.getUserMarketingDollars($ctrl.currentUser.Id)
            //];
            
            //$q.all(promises)
            //    .then(responses => {
            //        $ctrl.totalIssuedPremium = responses[0].TotalIssuedPremium;
            //        $ctrl.totalAum = responses[1];
            //        $ctrl.marketingDollars = responses[2].MarketingDollarsTotal;
            //    })
            //    .finally(() => {
            //        $ctrl.ui.loading = false;
            //    });
        };
    }

})(window.app, window.angular);